"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Style_1 = require("./Style");
let defaultStyle;
class MenuStyle extends Style_1.Style {
    constructor(style = {}) {
        super(style);
        const { appearance } = style;
        this._appearance = appearance;
    }
    static get DEFAULT() {
        return defaultStyle ? defaultStyle : (defaultStyle = new MenuStyle());
    }
    get appearance() {
        return this._appearance || "menulist-button";
    }
    set appearance(appearance) {
        this._appearance = appearance;
        this.doChangeStyle();
    }
    clone() {
        return new MenuStyle(this);
    }
}
exports.MenuStyle = MenuStyle;
